(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PatchReportPhotoDetailController', PatchReportPhotoDetailController);

    PatchReportPhotoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'DataUtils', 'entity', 'PatchReportPhoto', 'PatchReport'];

    function PatchReportPhotoDetailController($scope, $rootScope, $stateParams, DataUtils, entity, PatchReportPhoto, PatchReport) {
        var vm = this;
        vm.patchReportPhoto = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:patchReportPhotoUpdate', function(event, result) {
            vm.patchReportPhoto = result;
        });
        $scope.$on('$destroy', unsubscribe);

        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
    }
})();
